import { environmentData } from '../environments/env'

let runEnv = environmentData['run']

export const AzureConfig = {
  connectionString: environmentData[runEnv]['appInsightConnectionString'],
}
